// src/firebase.js
import { initializeApp, getApps } from "firebase/app";
import { getAuth, connectAuthEmulator } from "firebase/auth";
import { initializeFirestore, connectFirestoreEmulator } from "firebase/firestore";
import { getStorage, connectStorageEmulator } from "firebase/storage";
import { getFunctions, connectFunctionsEmulator } from "firebase/functions";

// 1) Config da ENV
const cfg = {
    apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
    authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
    projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
    storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
    messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
    appId: process.env.REACT_APP_FIREBASE_APP_ID,
};

// 2) Verifica ENV
if (!cfg.projectId) {
    console.error("ENV attive:", {
        REACT_APP_FIREBASE_API_KEY: !!process.env.REACT_APP_FIREBASE_API_KEY,
        REACT_APP_FIREBASE_AUTH_DOMAIN: !!process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
        REACT_APP_FIREBASE_PROJECT_ID: process.env.REACT_APP_FIREBASE_PROJECT_ID,
        REACT_APP_FIREBASE_STORAGE_BUCKET: !!process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
        REACT_APP_FIREBASE_APP_ID: !!process.env.REACT_APP_FIREBASE_APP_ID,
        REACT_APP_ENV: process.env.REACT_APP_ENV,
    });
    throw new Error("Firebase ENV mancanti: controlla .env.development / .env.production");
}

// 3) Inizializza app
const app = getApps().length ? getApps()[0] : initializeApp(cfg);



const onLocalhost = ["localhost", "127.0.0.1"].includes(window.location.hostname);
const isPrerendering = navigator.userAgent === 'ReactSnap';
if (onLocalhost && !isPrerendering && (cfg.projectId || "").includes("mima-7b65c")) {
    throw new Error("SAFEGUARD: DB di PRODUZIONE (mima-7b65c) vietato su localhost.");
}

// 🔕 App Check disattivato per lo staging
export const appCheck = null;

// 5) Servizi Firebase
export const auth = getAuth(app);
export const db = initializeFirestore(app, {
    experimentalAutoDetectLongPolling: true,
    useFetchStreams: false,
});
export const storage = getStorage(app);
export const functions = getFunctions(app, "us-central1");

// 6) Emulatori
const USE_EMU = String(process.env.REACT_APP_USE_EMULATORS || "").toLowerCase() === "true";
if (USE_EMU) {
    connectAuthEmulator(auth, "http://127.0.0.1:9099", { disableWarnings: true });
    connectFirestoreEmulator(db, "127.0.0.1", 8080);
    connectStorageEmulator(storage, "127.0.0.1", 9199);
    connectFunctionsEmulator(functions, "127.0.0.1", 5001);
}


// 7) Parabrezza anti-mix
const isProdBuild =
    process.env.NODE_ENV === "production" || process.env.REACT_APP_ENV === "production";
if (!isProdBuild && (cfg.projectId || "").includes("mima-7b65c")) {
    throw new Error("Stai avviando un ambiente non-prod con il projectId di PRODUZIONE (mima-7b65c).");
}

